import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import AlliedQuoteProposalInfoPageStore, {
  AlliedQuoteProposalInfoPageStoreContext,
  useAlliedQuoteProposalInfoPageStore,
} from 'store/pages/quote/quote-proposal-info/allied/pageStore';
import AlliedQuoteProposalInfoForm from 'components/quote/quote-proposal-info/Allied';

// TESTING_POLICY: CYPRESS_ONLY

const PageContent: React.FC = observer(() => {
  const { isActionLoading, flowDelegate, canCompleteStep, onComplete, getInitialData } =
    useAlliedQuoteProposalInfoPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={flowDelegate}
      pageId={QuoteRouteV2Id.QUOTE_PROPOSAL_INFO}
      isPageLoading={flowDelegate.isInitialDataLoading}
      isActionLoading={isActionLoading}
      pageHeader={{ subtitleMaxWidth: '50rem' }}
      pageFooter={{
        onComplete,
        completeButtonText: 'Save',
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <AlliedQuoteProposalInfoForm />
    </QuoteFlowLayout>
  );
});

const AlliedQuoteProposalInfoPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(
    () => new AlliedQuoteProposalInfoPageStore({ groupId, periodId, cartId }),
    [groupId, periodId, cartId],
  );

  return (
    <AlliedQuoteProposalInfoPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </AlliedQuoteProposalInfoPageStoreContext.Provider>
  );
};

export default AlliedQuoteProposalInfoPage;
